import { render, staticRenderFns } from "./LegendListField.vue?vue&type=template&id=81c0258c&"
import script from "./LegendListField.vue?vue&type=script&lang=js&"
export * from "./LegendListField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports